var map = {
	"./admin-controls.route.js": "./src/router/admin/admin-controls.route.js",
	"./attendance-sheets.route.js": "./src/router/admin/attendance-sheets.route.js",
	"./budget-code.route.js": "./src/router/admin/budget-code.route.js",
	"./client-applications.route.js": "./src/router/admin/client-applications.route.js",
	"./completion-reports.route.js": "./src/router/admin/completion-reports.route.js",
	"./customer-forecasts.route.js": "./src/router/admin/customer-forecasts.route.js",
	"./customers.route.js": "./src/router/admin/customers.route.js",
	"./dashboard.route.js": "./src/router/admin/dashboard.route.js",
	"./downtime-reports.route.js": "./src/router/admin/downtime-reports.route.js",
	"./elevator-trouble-logs.route.js": "./src/router/admin/elevator-trouble-logs.route.js",
	"./employees.route.js": "./src/router/admin/employees.route.js",
	"./incubators.route.js": "./src/router/admin/incubators.route.js",
	"./orders.route.js": "./src/router/admin/orders.route.js",
	"./preventive-maintenance.route.js": "./src/router/admin/preventive-maintenance.route.js",
	"./project-code.route.js": "./src/router/admin/project-code.route.js",
	"./purchase-requests.route.js": "./src/router/admin/purchase-requests.route.js",
	"./quotations.route.js": "./src/router/admin/quotations.route.js",
	"./reports.route.js": "./src/router/admin/reports.route.js",
	"./stocks.route.js": "./src/router/admin/stocks.route.js",
	"./suppliers.route.js": "./src/router/admin/suppliers.route.js",
	"./vouchers.route.js": "./src/router/admin/vouchers.route.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router/admin sync \\.route\\.js$";